import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Sidebar from "./Sidebar";
import BlueSidebar from "./BlueSidebar";
import PilotButton from "./PilotButton";
import { getSidebarPaths } from "@/features/router/sidebarPaths";
import { AppAccessBanner } from "@/features/access-control/components/shared/AppAccessBanner";
import { useAppAccess } from "@/features/access-control/hooks/useAppAccess";
import { useBootstrap } from "@/features/bootstrap";

export default function AppLayout({ children }) {
  const { pathname } = useLocation();
  const {
    access,
    role,
    isPaused,
    hasAnyPause,
    activeRestriction,
    districtRestriction,
    schoolRestriction,
  } = useAppAccess();
  const { data: bootstrap } = useBootstrap();

  const sidebarPaths = getSidebarPaths(role, isPaused);
  const useLightSidebar = sidebarPaths.has(pathname);
  const showBanner = isPaused || hasAnyPause;

  return (
    <>
      <AnimatePresence>
        {useLightSidebar ? (
          <Sidebar key="sidebar" />
        ) : (
          <BlueSidebar key="bluesidebar" />
        )}
      </AnimatePresence>

      {showBanner && (
        <AppAccessBanner
          role={role}
          access={access}
          supportPhone={bootstrap?.supportPhone ?? null}
          isPaused={isPaused}
          activeRestriction={activeRestriction}
          districtRestriction={districtRestriction}
          schoolRestriction={schoolRestriction}
        />
      )}

      {children}

      <PilotButton variant="floating" />
    </>
  );
}
